<!-- Inline Role Dialog Template -->
<ng-template #viewDetailDialog>
  <div
    class="flex justify-between items-center gap-8 sticky top-0 !bg-[#dee2e6]"
  >
    <div class="flex justify-start items-center gap-8 top-0 !bg-[#dee2e6]">
      <h3 class="header-title">Addendum No. {{ addendum?.id }}</h3>
    </div>
    <!-- Close Icon -->
    <div
      style="position: absolute; top: 10px; right: 36px; z-index: 50"
      (click)="closeDialog()"
    >
      <img
        src="assets/icons/cross-icon.svg"
        alt="cross icon"
        class="cursor-pointer !fixed"
      />
    </div>
  </div>

  <div class="inline-dialog">
    <div class="mx-auto mt-5">
      <h2 class="title-label">
        <span>Title :</span>
        <span class="ml-[5rem]">{{ addendum?.title }}</span>
      </h2>

      <div class="mt-4">
        <h3 class="title-label">Description:</h3>
        <p
          class="mt-2 description-valu"
          [innerHTML]="sanitizeHtml(addendum?.answer)"
        ></p>
      </div>

      <div class="mt-6">
        <h4 class="attach_document">
          <span>Attached Documents</span>
          <img
            class="rounded-full ml-[4px]"
            src="assets/icons/document.svg"
            alt="document icon"
          />
        </h4>
        <div class="flex gap-4 flex-wrap">
          <div *ngIf="addendum?.addendum_new_files?.length === 0">
            <p class="text-sm text-gray-500">No file attachment added</p>
          </div>
          <div *ngFor="let file of addendum?.addendum_new_files">
            <div
              class="flex flex-col items-center justify-center text-center cursor-pointer"
            >
              <div
                class="w-[7.09rem] h-[5.8rem] bg-white border mb-1 file-icon"
              ></div>
              <span class="file-name">{{
                file?.title?.length > 20
                  ? (file.title | slice : 0 : 2) + "..."
                  : file.title
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="dialog-actions">
      <button class="close-btn" (click)="closeDialog()">Close</button>
    </div>
  </div>
</ng-template>
